import { useState } from 'react'

import { useIsomorphicLayoutEffect, useMediaQuery } from 'usehooks-ts'

type Breakpoints = 'sm' | 'md' | 'lg' | 'xl' | '2xl'
interface UseIsBreakpointOptions {
    initializeWithValue?: boolean
    defaultValue?: boolean
}
export const useIsBreakpoint = (
    breakpoint: Breakpoints,
    { initializeWithValue = true, defaultValue = false }: UseIsBreakpointOptions = {},
): boolean => {
    const [breakpointValue, setBreakpointValue] = useState<string | null>(null)

    useIsomorphicLayoutEffect(() => {
        const value = getComputedStyle(document.documentElement)
            .getPropertyValue(`--breakpoint-${breakpoint}`)
            .trim()
        setBreakpointValue(value)
    }, [breakpoint])

    return useMediaQuery(`(max-width: calc(${breakpointValue} - 1px))`, {
        initializeWithValue,
        defaultValue,
    })
}
